module.exports = __webpack_public_path__ + "media/images/doctor-day/doctorday-template-am-a354d02759ad5c93ef3ba0dd43e1d78b.png";